import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Landing from './components/Landing';
import Investigator from './components/Investigator';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/investigator" element={<Investigator />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;